module.exports = __webpack_public_path__ + "img/White.c4b09816.jpg";